<template>
  <a-card class="m-display-flex flex-column nowrap">
    <span slot="title">PD Activity Report</span>
    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step title="Activity Detail" />
      <a-step title="File Attachment" />
    </a-steps>
    <div class="steps-content flex-1">
      <component class="flex-1" :is="steps[current].content" :ref="stepRef" v-bind="stepProps"></component>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" @click="next">Next</a-button>
        <a-button-group v-if="current == steps.length - 1">
          <a-button @click="saveDraft">Save as Draft</a-button>
          <a-button type="primary" @click="validate" :loading="loading.save">Save</a-button>
        </a-button-group>
        <a-button v-if="current > 0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import qs from "qs";
import moment from "moment";
import InformasiLapPD from "./steps/Informasi.vue";
import DetailKegiatan from "./steps/DetailKegiatan.vue";
import Lampiran from "./steps/Lampiran.vue";

export default {
  name: "LapPDCreate",
  props: ["id"],
  components: {
    InformasiLapPD,
    DetailKegiatan,
    Lampiran,
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "InformasiLapPD",
        },
        {
          title: "DetailKegiatan",
          content: "DetailKegiatan",
        },
        {
          title: "Lampiran",
          content: "Lampiran",
        },
      ],
      mode: "Create",
      collectData: {},
      listKegiatan: [],
      postData: new FormData(),
      postJson: {},
      editData: {},
      listDokumen: [],
      loading: {
        save: false,
      }
    };
  },
  computed: {
    ...mapGetters(["getAuth"]),
    initialListItem() {
      let data = [];
      let hargaTotal = 0;
      if (this.mode === "Edit") {
        this.listKegiatan.forEach((item) => {
          const values = item.values;
          data = [...data, { values }];
        });
      } else {
        data = this.listKegiatan;
        this.collectData.listBeli.forEach((item) => {
          data = [
            ...data,
            {
              values: item,
            },
          ];
        });
      }
      return data;
    },
    stepProps: function () {
      if (this.mode === "Edit") {
        if (this.steps[this.current].content === "InformasiLapPD") {
          return {
            collectData: this.collectData,
            mode: this.mode,
            isDraft: this.isDraft,
          };
        } else if (this.steps[this.current].content === "DetailKegiatan") {
          return {
            listKegiatan: this.initialListItem,
            listDokumen: this.listDokumen,
            collectData: this.collectData,
            mode: "Edit",
            id_pdlk: this.id,
            isDraft: this.isDraft,
          };
        } else if (this.steps[this.current].content === "Lampiran") {
          return {
            collectData: this.collectData,
            informasi: this.collectData.informasi,
            listDokumen: this.listDokumen,
            mode: "Edit",
            id_pdlk: this.id,
            isDraft: this.isDraft,
          };
        }
      } else if (this.mode === "Create") {
        if (this.steps[this.current].content === "InformasiLapPD") {
          return {
            collectData: this.collectData,
            mode: this.mode,
            isDraft: this.isDraft,
          };
        } else if (this.steps[this.current].content === "DetailKegiatan") {
          return {
            listKegiatan: this.listKegiatan,
            listDokumen: this.listDokumen,
            collectData: this.collectData,
            mode: this.mode,
            id_pdlk: this.id,
            isDraft: this.isDraft,
          };
        } else if (this.steps[this.current].content === "Lampiran") {
          return {
            listDokumen: this.listDokumen,
            collectData: this.collectData,
            mode: this.mode,
            id_pdlk: this.id,
            isDraft: this.isDraft,
          };
        }
      }
    },
    stepRef: function () {
      if (this.steps[this.current].content === "InformasiLapPD") {
        return "refInformasiLapPD";
      } else if (this.steps[this.current].content === "DetailKegiatan") {
        return "refDetailKegiatan";
      } else if (this.steps[this.current].content === "Lampiran") {
        return "refLampiran";
      }
    },
    isDraft() {
      return this.$route.meta.isDraft ? true : false
    }
  },
  created() {
    if (this.id && (this.$route.meta.mode && this.$route.meta.mode == 'edit')) {
      this.mode = "Edit";
      this.fetchDetail();
    } else if (this.id && !(this.$route.meta.mode && this.$route.meta.mode == 'edit')) {
      this.fetchDetail();
    }
  },
  methods: {
    moment,
    ...mapActions(["FETCH_ALLOCATION", "FETCH_USEDFOR"]),
    next() {
      if (this.steps[this.current].content === "InformasiLapPD") {
        this.$refs.refInformasiLapPD.handleRef();
      } else if (this.steps[this.current].content === "DetailKegiatan") {
        this.$refs.refDetailKegiatan.handleRef();
      } /* else if (this.steps[this.current].content === "Lampiran") {
        console.log("klik lampiran");
        this.$refs.refLampiran.handleRefBack();
      } */
    },
    prev() {
      if (this.steps[this.current].content === "Lampiran") {
        this.$refs.refLampiran.handleRefBack();
      }
      this.current--;
    },
    validate() {
      this.$refs.refLampiran.handleRef();
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "InformasiLapPD") {
        if (this.mode === "Create") {
          /* this.collectData.persetujuan = {
            pimpro: JSON.parse(JSON.stringify(value.pimpro_atasan.pimpro)),
            bod: JSON.parse(JSON.stringify(value.pimpro_atasan.bod))
          }; */
        } else {
          /* this.collectData.persetujuan = {
            pimpro: JSON.parse(JSON.stringify(value.pimpro_atasan.pimpro)),
            bod: JSON.parse(JSON.stringify(value.pimpro_atasan.bod)),
            catatan: this.collectData.persetujuan.catatan,
            atasan: this.collectData.persetujuan.atasan
          }; */
        }
        this.collectData.informasi = JSON.parse(
          JSON.stringify(value.informasi)
        );
        this.current++;
      } else if (this.steps[this.current].content === "DetailKegiatan") {
        /* this.collectData.estimated_value = JSON.parse(
          JSON.stringify(value.estimated_value)
        ); */
        this.current++;
      } else if (this.steps[this.current].content === "Lampiran") {
        /* this.collectData.persetujuan = JSON.parse(
          JSON.stringify(value.persetujuan)
        );

        console.log(this.collectData.persetujuan); */
        if (this.mode === "Edit") {
          this.confirmMessage("confirm-edit");
        } else {
          this.confirmMessage("confirm-save");
        }
      }
    },
    getListKegiatan(item) {
      this.listKegiatan = [
        ...this.listKegiatan,
        JSON.parse(JSON.stringify(item)),
      ];
      this.listKegiatan.sort((a, b) =>
        this.moment(a.values.tanggal).format("YYYYMMDD").toString() >=
          this.moment(b.values.tanggal).format("YYYYMMDD").toString()
          ? -1
          : this.moment(a.values.tanggal).format("YYYYMMDD").toString() <
            this.moment(b.values.tanggal).format("YYYYMMDD").toString()
            ? 1
            : 0
      );

      this.editData = [];
    },
    getUpdateKegiatan(item) {
      this.listKegiatan = [];
      this.listKegiatan.push(...item)
    },
    setSubmitForm() {
      if (this.id)
        this.postData.append("id_pdlk", this.id);
      this.postData.append("tlc", this.getAuth.username);
      this.postData.append("id_sppd", this.collectData.informasi.id_sppd);
      this.postData.append("tgl_buat", this.collectData.informasi.tgl_buat);
      this.postData.append("lokasi", this.collectData.informasi.lokasi);

      // this.listKegiatan.forEach((data) => {
      //   this.postData.append("tgl_kegiatan[]", data.values.tanggal);
      //   this.postData.append("pelaksana[]", this.arraytoText(data.values.pelaksana));
      //   this.postData.append("kegiatan[]", data.values.kegiatan);
      //   this.postData.append("hasil[]", data.values.hasil);
      // });
      // this.listDokumen.dokumenPendukung.forEach((data) => {
      //   this.postData.append("dokumen[]", data.file);
      //   this.postData.append("deskripsi[]", data.deskripsi);
      // });
    },
    submit() {
      this.setSubmitForm();
      let method = "";
      let data;
      let url;
      if (this.mode === "Create") {
        method = "post";
        data = this.postData;
        url = "lap_kegiatan_pd/submit";
      } else {
        method = "post";
        data = this.postData;
        url = "lap_kegiatan_pd/submit_revisi";
      }

      // Proses Hapus mode Edit sebelum proses Save
      // if (
      //   this.mode === "Edit" &&
      //   this.listDokumen.deleteExistingDoc != undefined
      // ) {
      //   if (this.listDokumen.deleteExistingDoc.length > 0) {
      //     this.listDokumen.deleteExistingDoc.forEach((item) => {
      //       let urlEncodeValue = qs.stringify({
      //         id: item[0].id_file,
      //       });

      //       axios({
      //         method: "DELETE",
      //         url: this.$serviceUrl + "lap_kegiatan_pd/del_lampiran",
      //         processData: false,
      //         data: urlEncodeValue,
      //         auth: {
      //           username: this.getAuth.username,
      //           password: this.getAuth.password,
      //         },
      //         headers: {
      //           "Content-Type":
      //             "application/x-www-form-urlencoded;charset=utf-8",
      //           "X-API-KEY": this.getAuth.apikey,
      //         },
      //       })
      //         .then((response) => {})
      //         .catch((err) => {
      //           console.log("error : " + err);
      //           this.displayMessage("error-delete-existing");
      //         });
      //     });
      //   }
      // }

      this.loading.save = true;
      axios({
        method: method,
        url: this.$serviceUrl + url,
        processData: false,
        data: data,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then(() => {
          if (this.mode === "Create") {
            this.displayMessage("success-save");
          } else {
            this.displayMessage("success-edit");
          }

          this.current = 0;
          this.loading.save = false;
          this.$router.push({ name: "lapKegPdList" });
        })
        .catch((err) => {
          console.log(err)
          this.loading.save = false;
          let response = Object.assign({}, err.response);
          if (response.data.status == false && response.data.message) {
            this.displayMessageValue("error-other", response.data.message);
          } else {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          }
          return;
        });
    },
    fetchDetail() {
      axios({
        method: "get",
        url: this.$serviceUrl + "Lap_kegiatan_pd/pdlk",
        params: {
          id_pdlk: this.id,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.collectData = {
            informasi: response.data.header[0],
            listpdEditMode: response.data.list_sppd,
          };

          response.data.dtl.forEach((item) => {
            this.listKegiatan = [...this.listKegiatan, { values: item }];
          });

          this.listDokumen = response.data.doc;
        })
        .catch((err) => {
          this.displayMessage("error-getdetil");
        });
    },
    getNewDokumen(item) {
      this.listDokumen = item;
    },
    getUpdateDokumen(item) {
      this.listDokumen = item;
      if (this.mode === "Edit") {
        this.confirmMessage("confirm-edit");
      } else {
        this.confirmMessage("confirm-save");
      }
    },
    arraytoText(array) {
      let text = ""
      array.forEach((element) => {
        text += (text == "" ? element : "," + element);
      });
      return text;
    },
    saveDraft() {
      const that = this;
      this.$confirm({
        title: "Are you sure to Save as Draft?",
        content: null,
        okText: "Yes",
        cancelText: "No",
        onOk() {
          that.displayMessageValue(
            "success-other",
            "Success Save as Draft!"
          );
          that.$router.push({ name: "lapKegPdList" });
        },
        onCancel() { },
      })
    },
    updateId(val) {
      console.log(val)
      this.id = val.id_pdlk;
    }
  },
  mounted() {
    this.FETCH_ALLOCATION();
    this.FETCH_USEDFOR();
    Event.$on("informasi", this.valueFromChild);
    Event.$on("listKegiatan", this.getListKegiatan);
    Event.$on("updateList", this.getUpdateKegiatan);
    Event.$on("updateDokumen", this.getUpdateDokumen);
    Event.$on("newDokumen", this.getNewDokumen);
    Event.$on("confirmMessageReturn", this.submit);
    Event.$on("updateIdpdlk", this.updateId);
  },
  beforeDestroy() {
    Event.$off("informasi", this.valueFromChild);
    Event.$off("listKegiatan", this.getListKegiatan);
    Event.$off("updateList", this.getUpdateKegiatan);
    Event.$off("updateDokumen", this.getUpdateDokumen);
    Event.$off("newDokumen", this.getNewDokumen);
    Event.$off("confirmMessageReturn", this.submit);
    Event.$off("updateIdpdlk", this.updateId);
  },
};
</script>

<style></style>
